import { mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import { routeIsPatient, routeIsProfessional, routeIsSettings } from '@/helpers/routes'

export default {
  ...mapGetters(['user', 'tenants', 'userIsProfessionalOrCompany', 'userIsProfessional']),
  settingsRouter () {
    const prefix = (isEmpty(this.user.type) || this.user.type === 'patient') ? 'settings' : 'professional'

    return prefix + '.profile.me'
  },
  routeIsSettings () {
    return routeIsSettings(this.$route)
  },
  routeIsPatient () {
    return routeIsPatient(this.$route)
  },
  routeIsProfessional () {
    return routeIsProfessional(this.$route)
  }
}



// WEBPACK FOOTER //
// ./src/layout/headers/menu/user/resources/computed.js